export default "__VITE_ASSET__TyR1Hxb___"